import React, { useContext, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import VideoJsContainer from './VideoJsContainer';
import WowzaPlayerContainer from './WowzaPlayerContainer';
import AntPlayer from './AntPlayer';
import PreviewVideo from './PreviewVideo';
import Chapters from '../../chapter/Chapters';
import './index.css';

// HELPERS
// import { getCurrentIndex } from '../../../helpers';

import WebcastingContext from '../../../context/webcasting/webcastingContext';
import PresenterItem from '../../presenter/PresenterItem';
import PresenterItemSmall from '../../presenter/PresenterItemSmall';

const VideoPlayer = ({
  media,
  isLive,
  title,
  preview,
  isOnlyVideo,
  getHeight,
  ispresenter,
  qnaMode,
  // 'fullscreen': beside the presenter only during on-demand fullscreen; 'always': on every on-demand playback
  chaptersBesidePresenter,
}) => {
  const webcastingContext = useContext(WebcastingContext);
  const { event, seekToTime, currentPresenter, playerCurrentTime, onDemandFullScreenMode } =
    webcastingContext;

  const activePresenterFromAPI = event.webcast.active?.presenter;


  const layoutfromAPI = event?.webcast?.layout;


  console.log('activePresenterFromAPI', activePresenterFromAPI)

  let presenters;
  let presentersTime;
  // let currentPresenter2;
  // let checkTime = true;
  let liveCurrentPresenter = [];
  const [activePresenter, setActivePresenter] = useState(0);
  const [previewHlsLive, setPreviewHlsLive] = useState(false);

  if (event) {
    presenters = event.presenters;
    presentersTime = event.webcast.presenterTimes;
  }

  const playerChapterLayouts = [
    ["Video", "Chapters"],
    ["Video", "Chapters", "Presenter"],
    ["Audio", "Video", "Chapters"],
    ["Audio", "Video", "Chapters", "Presenter"]
  ];

  function whichLayout(layout) {
    // Handle new API structure: layout is an object with boolean flags
    if (layout && typeof layout === 'object' && !Array.isArray(layout)) {
      // New structure: { video: true, chapters: true, presenters: true, ... }
      const hasVideo = Boolean(layout.video);
      const hasAudio = Boolean(layout.audio);
      const hasChapters = Boolean(layout.chapters);
      const hasPresenters = Boolean(layout.presenters);

      // Check if layout matches any of the valid combinations
      // We require chapters to be enabled, and at least video (audio is optional)
      // Other flags (slides, thumbnails, etc.) don't affect this check
      if (!hasChapters) return false;
      
      // Must have video (audio can be present or not, presenters can be present or not)
      return hasVideo;
    }

    // Handle old API structure: layout is an array of objects with name property
    if (Array.isArray(layout)) {
      // Extract names from layout array
      const layoutNames = layout.map(item => item.name);

      // Check if the layoutNames match any of the valid combinations
      return playerChapterLayouts.some(
        combination =>
          combination.every(name => layoutNames.includes(name)) && // Ensure all required names are present
          combination.length === layoutNames.length // Ensure no extra items
      );
    }

    return false;
  }

  // if (event.items[0].webcast.live.active.presenter) {
  //   presenters.forEach((p) => {
  //     if (p._id === event.items[0].webcast.live.active.presenter) {
  //       // console.log(
  //       //   'ACTIVE PRESENTER FOUND: ',
  //       //   event.items[0].webcast.live.active.presenter
  //       // );
  //       currentPresenter2 = [];
  //       currentPresenter2[0] = p;
  //     }
  //   });
  // }

  // if (presentersTime.length === 0) {
  //   currentPresenter2 = [presenters[0]];
  // } else {
  //   presentersTime.forEach((pTime) => {
  //     if (checkTime && pTime.time > (seekToTime || playerCurrentTime)) {
  //       checkTime = false;
  //     }
  //     if (checkTime) {
  //       currentPresenter2 = presenters.filter(
  //         (p) => p._id || p.id === pTime.presenterId
  //       );
  //     }
  //   });
  // }
  function getCurrentPresenter(time, array, pres) {
    console.log('wowgg time', time)
    console.log('wowgg array', array)
    console.log('wowgg pres', pres)
    let index = 0;
    array.forEach((el, idx) => {
      if (el.time <= time) {
        index = idx;
      }
    });

    console.log('wow1array[index]', array)
    console.log('wow1pres', pres)
    console.log('wow presentersTime', presentersTime)

 

    const wanted = array[index]?.presenterId;
    return pres.filter(
      (e) => e._id === wanted || e.oldId === wanted || e.id === wanted
    );
  }

  useEffect(() => {
    let t = playerCurrentTime || seekToTime;

    if (!isLive) {
      if (presentersTime.length === 0) {
        setActivePresenter([presenters[0]]);
      } else {
        console.log('presentersTimeFromUseEffect', presentersTime)
        setActivePresenter(getCurrentPresenter(t, presentersTime, presenters));
      }
    }

    // eslint-disable-next-line
  }, [playerCurrentTime, seekToTime]);

  useEffect(() => {
    if (!preview) return undefined;

    const hlsUrl = typeof media?.wowza?.hls_url === 'string' ? media.wowza.hls_url.trim() : '';
    if (!hlsUrl) return undefined;

    let cancelled = false;

    fetch(hlsUrl, { cache: 'no-store' })
      .then((response) => (response.ok ? response.text() : ''))
      .then((playlist) => {
        if (cancelled) return;
        const live =
          playlist.includes('#EXTM3U') &&
          !playlist.includes('#EXT-X-ENDLIST') &&
          (playlist.includes('#EXTINF') ||
            playlist.includes('#EXT-X-PART') ||
            playlist.includes('#EXT-X-STREAM-INF'));
        setPreviewHlsLive(live);
      })
      .catch(() => {
        if (!cancelled) setPreviewHlsLive(false);
      });

    return () => {
      cancelled = true;
    };
  }, [preview, media?.wowza?.hls_url]);

  // Next IF statements set current presenter for live event
  if (
    currentPresenter === null &&
    activePresenterFromAPI === null
  ) {
    liveCurrentPresenter.push(presenters[0]);
  } else if (
    activePresenterFromAPI !== null &&
    currentPresenter === null || currentPresenter === undefined || Object.keys(currentPresenter).length === 0
    //currentPresenter can be empty object
  ) {
    const cP = presenters.filter(
      (p) =>
        p._id === activePresenterFromAPI ||
        p.oldId === activePresenterFromAPI ||
        p.id === activePresenterFromAPI
    );
    console.log('activePresenterFromAPIcP', cP)
    liveCurrentPresenter.push(cP[0]);
  } else {
    console.log('activePresenterFromAPIcurrentPresenterFromVideoPlayer', currentPresenter)
    liveCurrentPresenter.push(currentPresenter);
  }

  // Next lines of code was for PresenterItem in WowzaPlayer and AntPlayer
  // related to wpv-71 in Jira
  // active={
  // liveStatus === 'presenter'
  //   ? currentPresenter
  //   : currentPresenter2[0]
  // }

  const onDemandPresenter =
    ispresenter === 'off' ? null : (
      <PresenterItemSmall
        active={activePresenter[0]}
        isOnlyVideo={isOnlyVideo}
      />
    );

  const showChaptersBesidePresenter =
    !isLive &&
    (chaptersBesidePresenter === 'always' ||
      (chaptersBesidePresenter === 'fullscreen' && onDemandFullScreenMode));

  const onDemandPresenterArea =
    showChaptersBesidePresenter ? (
      <div className='presenter-chapters-row'>
        <div className='presenter-chapters-row__presenter'>{onDemandPresenter}</div>
        <div className='presenter-chapters-row__chapters'>
          <Chapters preview={preview} />
        </div>
      </div>
    ) : (
      onDemandPresenter
    );

  return (
    <div style={{ height: '100%' }}>

        {isLive === true && media?.wowza?.streamId !== '' ? (
          <div className='video-player-container' style={{ height: '100%' }}>
            {!preview ? (
              <WowzaPlayerContainer
                media={media}
                title={title}
                isLive={true}
                preview={preview}
                event={event}
                isOnlyVideo={isOnlyVideo}
                getHeight={getHeight}
                qnaMode={qnaMode}
              />
            ) : previewHlsLive ? (
              <WowzaPlayerContainer
                media={media}
                title={title}
                isLive={true}
                preview={preview}
                event={event}
                isOnlyVideo={isOnlyVideo}
                getHeight={getHeight}
                qnaMode={qnaMode}
              />
            ) : (
              <PreviewVideo />
            )}
            {
              ispresenter === 'off' ? <></> : (

                isMobile || isOnlyVideo ? (
                  <PresenterItemSmall
                    active={liveCurrentPresenter[0]}
                    isOnlyVideo={isOnlyVideo}
                  />
                ) : (
                  <PresenterItem
                    active={liveCurrentPresenter[0]}
                    presenterCardColors={event?.webcast?.branding?.presenterCard}
                    // active={
                    //   liveStatus !== undefined
                    //     ? liveCurrentPresenter[0]
                    //     : liveCurrentPresenter[0]
                    //   // : currentPresenter2[0]
                    // }
                    small={true}
                  />
                ))
            }
          </div>
        ) : isLive === true && media.antMediaSrc !== '' ? (
          <div className='video-player-container' style={{ height: '100%' }}>
            <AntPlayer
              media={media}
              title={title}
              isLive={true}
              preview={preview}
              event={event}
              isOnlyVideo={isOnlyVideo}
            />
            {isMobile || isOnlyVideo ? (
              <PresenterItemSmall
                active={liveCurrentPresenter[0]}
                isOnlyVideo={isOnlyVideo}
              />
            ) : (
              <PresenterItem active={liveCurrentPresenter[0]} small={true} />
            )}
          </div>
        ) : isLive === false && whichLayout(layoutfromAPI) ? (
          // <div id='videoPlayerBC' className='videoBC-presenter-container'>
                       <div id='videoPlayerBC' className={`video-player-container${onDemandFullScreenMode ? ' video-player-container--qnaFullscreen' : ''}`}> 

            <VideoJsContainer
              media={media}
              isOnlyVideo={isOnlyVideo}
              preview={preview}
              getHeight={getHeight}
            />

            {onDemandPresenterArea}

          </div>
        )

          : (
            <div className={`video-player-container${onDemandFullScreenMode ? ' video-player-container--qnaFullscreen' : ''}`} style={{ height: '100%' }}>
              <VideoJsContainer
                media={media}
                isOnlyVideo={isOnlyVideo}
                preview={preview}
                getHeight={getHeight}
              />

              {onDemandPresenterArea}

            </div>
          )}
    </div>
  );
};

export default React.memo(VideoPlayer);
